import { UserAction } from '../../../enums'
import { errorHandler } from '../../middleware'
import smartAuthAPI from '../smartbestbuys-api'
import { BaseData } from '../types'

export const getActionMessagesByUserAction = errorHandler<BaseData[]>((userAction: UserAction) => {
  return smartAuthAPI.get(`/user-activities/user-actions/${userAction}/messages`)
})
